import React from 'react';
import { InputText } from 'primereact/inputtext';

import PropTypes from 'prop-types';

const CustomInput = ({
  name,
  value,
  onChange,
  placeholder,
  type,
  tooltip,
  tooltipOptions,
  error,
  errorMessage,
  disabled,
  helper,
}) => {
  return (
    <div className="flex flex-column padding_0">
      {type === 'number' ? (
        <input
          type="text"
          pattern="[0-9]*"
          name={name}
          min={1}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`p-inputtext p-component block ${error ? 'p-invalid' : ''}`}
          disabled={disabled}
        />
      ) : (
        <InputText
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={error ? 'block p-invalid' : 'block'}
          type={type}
          tooltip={tooltip}
          tooltipOptions={tooltipOptions}
          disabled={disabled}
        />
      )}
      {helper && !error && (
        <p className="align-self-start" style={{ color: '#8D8D8D', marginTop: '5px' }}>
          {helper}
        </p>
      )}
      {error && (
        <p className="align-self-start" style={{ color: 'red', marginTop: '5px' }}>
          {errorMessage}
        </p>
      )}
    </div>
  );
};

CustomInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipOptions: PropTypes.objectOf(PropTypes.any),
  error: PropTypes.any,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  helper: PropTypes.string,
};

CustomInput.defaultProps = {
  error: undefined,
  errorMessage: undefined,
  tooltip: undefined,
  type: undefined,
  tooltipOptions: undefined,
  disabled: false,
  helper: undefined,
};

export default CustomInput;
